import { Option } from '@common/components/inputs/Select';
import dayjs from 'dayjs';

export interface PayslipPeriodOptionsParams {
  from: string | Date;
  to: string | Date;
  order: 'asc' | 'desc';
}

// Returns an array of option to select a payslip period
// Payslip period are serialized as the last day of the month in YYYY-MM-DD format
// @param from: a date within the firts period
// @param to: a date within the last period
// @param order: the order of the options (default to :desc)
export function usePayslipPeriodOptions(
  {
    from = '2022-01-01',
    to = new Date(),
    order = 'desc',
  }: PayslipPeriodOptionsParams = {} as unknown as PayslipPeriodOptionsParams,
): Option[] {
  const fromDate = dayjs(from);
  const toDate = dayjs(to);

  const options: Option[] = [];
  let currentDate = fromDate.startOf('month');

  while (currentDate.isBefore(toDate) || currentDate.isSame(toDate, 'month')) {
    const lastDayOfMonth = currentDate.endOf('month');
    const value = lastDayOfMonth.format('YYYY-MM-DD');
    const label = lastDayOfMonth.format('MMMM YYYY');

    options.push({ value, label });
    currentDate = currentDate.add(1, 'month');
  }

  return order === 'desc' ? options.reverse() : options;
}
